/* import __COLOCATED_TEMPLATE__ from './participant-blocked.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ParticipantBlocked from 'embercom/objects/inbox/renderable/participant-blocked';
import { KILLSWITCH_FLAG_NAME } from 'embercom/lib/inbox2/event-text-truncation';

interface ParticipantBlockedPart extends RenderablePart {
  renderableData: ParticipantBlocked;
}

interface Args {
  part: ParticipantBlockedPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsParticipantBlockedPartComponent extends Component<Signature> {
  @service declare session: Session;

  get renderableData() {
    return this.args.part.renderableData;
  }

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return !this.session.workspace?.isFeatureEnabled(KILLSWITCH_FLAG_NAME);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ParticipantBlocked': typeof Inbox2ConversationStreamEventPartsParticipantBlockedPartComponent;
    'inbox2/conversation-stream/event-parts/participant-blocked': typeof Inbox2ConversationStreamEventPartsParticipantBlockedPartComponent;
  }
}
